"use client";

import Link from "next/link";

export default function PilotsPage() {
  return (
    <main className="max-w-4xl mx-auto p-6 space-y-8">
      <h1 className="text-3xl font-bold text-amber-400 uppercase mb-6">
        FOR PILOTS
      </h1>

      <section>
        <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
          ASPIRING PILOTS - PLAN YOUR JOURNEY TO THE FLIGHT DECK
        </h2>
        <p className="text-gray-300">
          Understanding the costs, routes, and challenges of becoming a pilot can be daunting. Our Starter
          Support Package gives you clear information on the best training routes, realistic costs, and what to
          expect at each stage. With years of experience in airline recruitment, we can help you prepare for
          selection, training, and life as a pilot - saving you false starts and wasted opportunities.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
          FLIGHT TRAINING SUPPORT - BEAT STICKING POINTS, SAVE TIME AND MONEY
        </h2>
        <p className="text-gray-300">
          Pilot training is intense, and almost every student hits a sticking point along the way. With decades of
          experience as ground and flight instructors, we provide highly focused, personal support to help you
          progress faster - and reduce costly repeat exercises or exams.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
          AIRLINE SELECTION SUPPORT - PREPARE FOR ASSESSMENTS AND INTERVIEWS
        </h2>
        <p className="text-gray-300">
          Landing your first airline job is often the hardest step. Pilot selection is usually a "deselection" process,
          designed to narrow down candidates before interview or simulator stages. With first-hand experience
          recruiting pilots, we know what recruiters are looking for - and how to present yourself for success.
          Don't leave your one chance to luck - prepare with us.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-amber-400 uppercase mb-2">
          COMMAND & LEADERSHIP DEVELOPMENT - STEP CONFIDENTLY INTO SENIOR ROLES
        </h2>
        <p className="text-gray-300">
          Even experienced pilots need guidance to reach their full potential. If you're preparing for a command
          upgrade, management role, or leadership position, we'll help you develop the skills you need - from
          decision-making and situational awareness to communication and team leadership.
        </p>
      </section>

      {/* CTA Line */}
      <section className="pt-8">
        <p className="text-cyan-400 font-semibold text-left">
          <Link
            href="/contact"
            className="hover:underline hover:text-green-400 transition-colors"
          >
            Contact us
          </Link>{" "}
          now to start your journey...
        </p>
      </section>
    </main>
  );
}
